import type { DoctorSlotsByDate } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuScheduleCalendar/types'

type TelemedDay = {
  date: string
  slots: Array<{
    time_start: string
    duration: number
    free?: boolean
  }>
}

/**
 * Телемед-слоты: `time_start` и duration в минутах → тот же формат календаря.
 */
export default function mapTelemedSlots(
  schedule: TelemedDay[] | undefined,
  doctorId: number,
): DoctorSlotsByDate {
  if (!schedule?.length) {
    return {}
  }

  return Object.fromEntries(
    schedule.map(day => [
      day.date,
      day.slots
        // `only_free` уже на API; как в mapDoctorSlots — не отбрасываем слоты без `free`
        .filter(slot => slot.free !== false)
        .map(slot => ({
          time: slot.time_start,
          duration: slot.duration * 60,
          doctor_id: doctorId,
        }))
        .filter(slot => slot.time),
    ]),
  )
}
